import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { DonateScreenComponent } from './donate-screen/donate-screen.component';
import { SettingScreenComponent } from './setting-screen/setting-screen.component';
import { ControllScreenComponent } from './controll-screen/controll-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterScreenComponent } from './register-screen/register-screen.component';
import { VerifyScreenComponent } from './verify-screen/verify-screen.component';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from 'angularx-social-login';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WaitScreenComponent } from './wait-screen/wait-screen.component';
import { DonateChangeService } from './donate-change.service';
import { NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CheckUidService } from './check-uid.service';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { PlayScreenComponent } from './play-screen/play-screen.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { HashtutorialComponent } from './hashtutorial/hashtutorial.component';
import {MatSliderModule} from '@angular/material/slider';
import {MatTableModule} from '@angular/material/table';
import { ControlService } from './controll-screen/control.service';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { PlayVideoScreenComponent } from './play-video-screen/play-video-screen.component';
import { PlayDonateComponent } from './play-donate/play-donate.component';
import { OverviewComponent } from './overview/overview.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LotteryComponent } from './lottery/lottery.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    AppComponent,
    DonateScreenComponent,
    SettingScreenComponent,
    ControllScreenComponent,
    RegisterScreenComponent,
    VerifyScreenComponent,
    WaitScreenComponent,
    PlayScreenComponent,
    HashtutorialComponent,
    PlayVideoScreenComponent,
    PlayDonateComponent,
    OverviewComponent,
    LotteryComponent,
  ],
  entryComponents: [
    HashtutorialComponent
  ],
  imports: [
    AppRoutingModule,
    FontAwesomeModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatTableModule,
    MatPaginatorModule,
    MatListModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatButtonModule,
    MatRadioModule,
    HttpClientModule,
    ClipboardModule,
    MatIconModule,
    MatSelectModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    SocialLoginModule,
    NgxYoutubePlayerModule,
    MatInputModule,
    SocialLoginModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    ScrollingModule,
  ],
  exports: [
    ControllScreenComponent,
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '1074429597747-3t8a3k07eambkurmhh2suq91vrvp57r1.apps.googleusercontent.com'
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('1074429597747-3t8a3k07eambkurmhh2suq91vrvp57r1.apps.googleusercontent.com'),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    DonateChangeService,
    CookieService,
    PlayScreenComponent,
    CheckUidService,
    ControlService,
    AppComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
